// START_MODULE pages_main_sections_gallery_styled_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import styled from 'styled-components';

export const GalleryImage = styled.img`
  max-height: 300px;
  object-fit: cover;

  margin-bottom: 28px;
`;

// END_MODULE pages_main_sections_gallery_styled_ts
